import axios from 'axios'

/**
 * Server-driven runtime client config from the App backend's public `GET /api/client-config`, read once
 * per session (the promise is memoized). Mirrors the App SPA service. On any error we fall back to the
 * defaults so a transient blip never flips behavior.
 *
 * Flags:
 *  - userPhotoServiceEnabled: true → fetch avatars from `GET /api/user/photo`; false → fall back to the
 *    legacy client-side Microsoft Graph fetch. Default ON.
 */
const DEFAULT_CONFIG = { userPhotoServiceEnabled: true }

let configPromise = null

export function getClientConfig() {
  if (!configPromise) {
    configPromise = axios
      .get('/api/client-config')
      .then(res => ({ ...DEFAULT_CONFIG, ...(res?.data ?? {}) }))
      .catch(() => {
        // Don't pin the session to defaults on a transient failure — clear the memo so the next call retries.
        configPromise = null
        return DEFAULT_CONFIG
      })
  }
  return configPromise
}
